export enum LinkTypeEnum {
    BUTTON = 'button',
    LINK = 'link',
}
